import { render, staticRenderFns } from "./AddDomain.vue?vue&type=template&id=19935b0b&scoped=true"
import script from "./AddDomain.vue?vue&type=script&lang=js"
export * from "./AddDomain.vue?vue&type=script&lang=js"
import style0 from "./AddDomain.vue?vue&type=style&index=0&id=19935b0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19935b0b",
  null
  
)

export default component.exports